import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-completed",
  "use": "icon-completed-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol viewBox=\"0 0 10 10\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-completed\"><path clip-rule=\"evenodd\" d=\"m5 9c2.20914 0 4-1.79086 4-4s-1.79086-4-4-4-4 1.79086-4 4 1.79086 4 4 4zm-1.78792-4.31214c-.11716-.11716-.30711-.11716-.42426 0-.11716.11716-.11716.30711 0 .42427l1.43609 1.43609c.19526.19526.51184.19526.7071 0l2.39113-2.39113c.11716-.11716.11716-.30711 0-.42426-.11716-.11716-.30711-.11716-.42427 0l-2.32041 2.32041z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol